import { Moment } from "moment";
import { HistorySortInput } from "history/reducer";

export enum ActionType {
  SetSelectedDate = "SET_SELECTED_DATE",
  SetSortOptions = "SET_SORT_OPTIONS",
}

export interface SetSelectedDateAction {
  type: ActionType.SetSelectedDate;
  payload: Moment;
}

export const setSelectedDate = (date: Moment): SetSelectedDateAction => ({
  type: ActionType.SetSelectedDate,
  payload: date,
});

export interface SetSortOptionsAction {
  type: ActionType.SetSortOptions;
  payload: HistorySortInput[];
}

export const setSortOptions = (
  options: HistorySortInput[],
): SetSortOptionsAction => ({
  type: ActionType.SetSortOptions,
  payload: options,
});
